<div class="order-component">
    <!-- Subcription Not Found  -->
    <div *ngIf="errorMessage" class="d-flex justify-content-center align-items-center">
        <div class="parent-container d-flex justify-content-center align-items-center">
            <div class="icon-container">
            </div>
            <div class="text-container">
                <div>
                    <p style="font-size: 80px; font-weight: bold">404</p>
                    <p style="font-size: 20px; font-weight: bold">Oops! Subscription Not Found</p>
                    <p>The subscription you're looking for doesn't exist. </p>
                </div>
                <div>
                    <button class="subscriptions-button" (click)="onBackToSubscriptionsPageClick()"> <- Back To
                            Subscriptions Page</button>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="!errorMessage">
        <div class="label-container">
            <button class="custom-back-button" title="Subscription Plans" (click)="onSubcriptionPlansBtnClick()">
                <span class="material-symbols-outlined">arrow_left_alt</span>
                Back
            </button>
            <h2>Personal Details</h2>
        </div>
        <div class="form-containers">
            <div class="row">
                <div class="col-7">
                    <form [formGroup]="orderForm">
                        <div class="row">
                            <!-- Billing Address -->
                            <div class="col-12" formGroupName="billingAddress">

                                <h4>Billing Address</h4>
                                <div class="mb-3">
                                    <label for="billingAddress-line1" class="form-label">Address Line 1 <span
                                            class="text-danger">*</span></label>
                                    <input type="text" class="form-control" id="billingAddress-line1" required
                                        formControlName="line1" [ngClass]="{'is-invalid': orderForm.get('billingAddress.line1')?.invalid &&
                                         (orderForm.get('billingAddress.line1')?.touched
                                        || orderForm.get('billingAddress.line1')?.dirty )}">
                                    <div
                                        *ngIf="orderForm.get('billingAddress.line1')?.invalid
                                        && (orderForm.get('billingAddress.line1')?.touched || orderForm.get('billingAddress.line1')?.dirty)">
                                        <ng-container *ngIf="orderForm.get('billingAddress.line1')?.errors as errors">
                                            <small class="text-danger" *ngIf="errors['required']">
                                                Address Line 1 is required.
                                            </small>
                                            <small class="text-danger"
                                                *ngIf="!errors['required'] && errors['onlySpaces']">
                                                Address Line 1 cannot contain only spaces.
                                            </small>
                                            <small class="text-danger"
                                                *ngIf="!errors['required'] && !errors['onlySpaces'] && errors['maxlength']">
                                                Address Line 1 must be 200 characters or less.
                                            </small>
                                            <small class="text-danger"
                                                *ngIf="!errors['required'] && !errors['onlySpaces'] && !errors['maxlength'] && errors['maxlengthNoSpaces']">
                                                Address Line 1 (excluding spaces) must be 200 characters or less.
                                            </small>
                                            <small class="text-danger"
                                                *ngIf="!errors['required'] && !errors['onlySpaces'] && !errors['maxlength'] && !errors['maxlengthNoSpaces'] && errors['invalidPattern']">
                                                Address Line 1 contains invalid characters (only letters, numbers,
                                                spaces, and - , . / ( ) & # are allowed).
                                            </small>
                                        </ng-container>
                                    </div>
                                </div>

                                <div class="mb-3">
                                    <label for="billingAddress-line2" class="form-label">Address Line 2 </label>
                                    <input type="text" class="form-control" id="billingAddress-line2"
                                        formControlName="line2" [ngClass]="{'is-invalid': orderForm.get('billingAddress.line2')?.invalid &&
                                         (orderForm.get('billingAddress.line2')?.touched
                                        || orderForm.get('billingAddresss.line2')?.dirty)}">
                                    <div
                                        *ngIf="orderForm.get('billingAddress.line2')?.invalid
                                         && (orderForm.get('billingAddress.line2')?.touched || orderForm.get('billingAddress.line2')?.dirty)">
                                        <ng-container *ngIf="orderForm.get('billingAddress.line2')?.errors as errors">
                                            <small class="text-danger" *ngIf="errors['onlySpaces']">
                                                Address Line 2 cannot contain only spaces.
                                            </small>
                                            <small class="text-danger"
                                                *ngIf="!errors['onlySpaces'] && errors['maxlength']">
                                                Address Line 2 must be 200 characters or less.
                                            </small>
                                            <small class="text-danger"
                                                *ngIf="!errors['required'] && !errors['onlySpaces'] && !errors['maxlength'] && errors['maxlengthNoSpaces']">
                                                Address Line 2 (excluding spaces) must be 200 characters or less.
                                            </small>
                                            <small class="text-danger"
                                                *ngIf="!errors['required'] && !errors['onlySpaces'] && !errors['maxlength'] && !errors['maxlengthNoSpaces'] && errors['invalidPattern']">
                                                Address Line 2 contains invalid characters (only letters, numbers,
                                                spaces, and - , . / ( ) & # are allowed).
                                            </small>
                                        </ng-container>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-6 mb-3">
                                        <label id="billingAddress-city" for="zip" class="form-label">
                                            City <span class="text-danger">*</span>
                                        </label>
                                        <input type="text" class="form-control" id="billingAddress-city" required
                                            formControlName="city"
                                            [ngClass]="{'is-invalid': orderForm.get('billingAddress.city')?.invalid &&
                                             (orderForm.get('billingAddress.city')?.touched || orderForm.get('billingAddress.city')?.dirty)}">
                                        <div *ngIf="(orderForm.get('billingAddress.city')?.touched || orderForm.get('billingAddress.city')?.dirty)
                                                && orderForm.get('billingAddress.city')?.invalid">

                                            <ng-container
                                                *ngIf="orderForm.get('billingAddress.city')?.errors as errors">
                                                <small class="text-danger" *ngIf="errors['required']">
                                                    City is required.
                                                </small>

                                                <small class="text-danger"
                                                    *ngIf="!errors['required'] && errors['onlySpaces']">
                                                    City cannot contain only spaces.
                                                </small>

                                                <small class="text-danger"
                                                    *ngIf="!errors['required'] && !errors['onlySpaces'] && errors['maxlength']">
                                                    City must be 100 characters or less.
                                                </small>

                                                <small class="text-danger"
                                                    *ngIf="!errors['required'] && !errors['onlySpaces'] && !errors['maxlength'] && errors['maxlengthNoSpaces']">
                                                    City (excluding spaces) must be 100 characters or less.
                                                </small>

                                                <small class="text-danger"
                                                    *ngIf="!errors['required'] && !errors['onlySpaces'] && !errors['maxlength'] && !errors['maxlengthNoSpaces'] && errors['pattern']">
                                                    City can only contain letters, spaces, and hyphens (-).
                                                </small>
                                            </ng-container>
                                        </div>
                                    </div>

                                    <div class="col-6 mb-3">
                                        <label id="billingAddress-postalCode" for="zip" class="form-label">
                                            Postal Code <span class="text-danger">*</span>
                                        </label>
                                        <input type="text" class="form-control" id="billingAddress-postalCode"
                                            placeholder="3-12 character postal code" required
                                            formControlName="postalCode"
                                            [ngClass]="{'is-invalid': orderForm.get('billingAddress.postalCode')?.invalid
                                            && (orderForm.get('billingAddress.postalCode')?.touched || orderForm.get('billingAddress.postalCode')?.dirty)}">
                                        <div *ngIf="(orderForm.get('billingAddress.postalCode')?.touched || orderForm.get('billingAddress.postalCode')?.dirty)
                                            && orderForm.get('billingAddress.postalCode')?.invalid">

                                            <ng-container
                                                *ngIf="orderForm.get('billingAddress.postalCode')?.errors as errors">

                                                <small class="text-danger" *ngIf="errors['required']">
                                                    Postal code is required.
                                                </small>

                                                <small class="text-danger"
                                                    *ngIf="!errors['required'] && errors['onlySpaces']">
                                                    Postal code cannot contain only spaces.
                                                </small>

                                                <small class="text-danger"
                                                    *ngIf="!errors['required'] && !errors['onlySpaces'] && errors['leadingOrTrailingSpaces']">
                                                    Postal code cannot start or end with a space.
                                                </small>

                                                <small class="text-danger"
                                                    *ngIf="!errors['required'] && !errors['onlySpaces'] && !errors['leadingOrTrailingSpaces'] && errors['maxlength']">
                                                    Postal code cannot exceed 12 characters.
                                                </small>

                                                <small class="text-danger"
                                                    *ngIf="!errors['required'] && !errors['onlySpaces'] && !errors['leadingOrTrailingSpaces'] && !errors['maxlength'] && errors['pattern']">
                                                    Postal code must be 3-12 characters, using only letters, numbers,
                                                    spaces, or hyphens.
                                                </small>

                                            </ng-container>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-6 mb-3">
                                        <label for="billingAddress-country" class="form-label">
                                            Country <span class="text-danger">*</span>
                                        </label>
                                        <select id="billingAddress-country" formControlName="country"
                                            class="form-control"
                                            [ngClass]="{'is-invalid': orderForm.get('billingAddress.country')?.invalid &&
                                            ((orderForm.get('billingAddress.country')?.touched) || orderForm.get('billingAddress.country')?.dirty)}">
                                            <option value="" disabled selected>Select Country</option>
                                            <option *ngFor="let country of countriesOptions$ | async"
                                                [value]="country.code">
                                                {{ country.name }}
                                            </option>
                                        </select>
                                        <div *ngIf="(orderForm.get('billingAddress.country')?.touched || orderForm.get('billingAddress.country')?.dirty)
                                         && orderForm.get('billingAddress.country')?.invalid">
                                            <small class="text-danger"
                                                *ngIf="orderForm.get('billingAddress.country')?.errors?.['required']">
                                                Country is required.
                                            </small>
                                        </div>
                                    </div>

                                    <div class="col-6 mb-3">
                                        <label for="billingAddress-state" class="form-label">
                                            State <span class="text-danger">*</span>
                                        </label>
                                        <select id="billingAddress-state" formControlName="state" class="form-control"
                                            [ngClass]="{'is-invalid': orderForm.get('billingAddress.state')?.invalid &&
                                            (orderForm.get('billingAddress.state')?.touched || orderForm.get('billingAddress.state')?.dirty)}">
                                            <option value="" disabled selected>Select State</option>
                                            <option *ngFor="let state of billingStatesOptions" [value]="state">
                                                {{ state }}
                                            </option>
                                        </select>
                                        <div *ngIf="(orderForm.get('billingAddress.state')?.touched || orderForm.get('billingAddress.state')?.dirty)
                                         && orderForm.get('billingAddress.state')?.invalid">
                                            <small class="text-danger"
                                                *ngIf="orderForm.get('billingAddress.state')?.errors?.['required']">
                                                State is required.
                                            </small>
                                        </div>
                                    </div>

                                    <div class="mb-3 col-6" *ngIf="showGSTOptions">
                                        <label for="billingAddress-gst" class="form-label">GSTIN</label>
                                        <input type="text" class="form-control text-uppercase" id="billingAddress-gst"
                                            formControlName="gst" [ngClass]="{
                                                'is-invalid': orderForm.get('billingAddress.gst')?.invalid &&
                                                (orderForm.get('billingAddress.gst')?.touched || orderForm.get('billingAddress.gst')?.dirty)
                                                }">
                                        <div
                                            *ngIf="orderForm.get('billingAddress.gst')?.invalid &&
                                            (orderForm.get('billingAddress.gst')?.touched || orderForm.get('billingAddress.gst')?.dirty)">
                                            <ng-container *ngIf="orderForm.get('billingAddress.gst')?.errors as errors">
                                                <small class="text-danger" *ngIf="errors['onlySpaces']">
                                                    GSTIN cannot contain only spaces.
                                                </small>
                                                <small class="text-danger"
                                                    *ngIf="!errors['onlySpaces'] && errors['maxlength']">
                                                    GSTIN must be exactly 15 characters.
                                                </small>
                                                <small class="text-danger"
                                                    *ngIf="!errors['onlySpaces'] && !errors['maxlength'] && errors['pattern']">
                                                    Invalid GSTIN format.
                                                </small>
                                            </ng-container>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <!-- Shipping Address -->
                            <div class="col-12">
                                <!-- Same As Billing Checkbox -->
                                <div class="form-check my-3">
                                    <input type="checkbox" class="form-check-input" id="sameAsBilling"
                                        formControlName="sameAsBillingCheckbox" (change)="onSameAsBillingChange()">
                                    <label class="form-check-label" for="sameAsBilling">Same As Billing
                                        Address</label>
                                </div>

                                <div class="form-check my-3">
                                    <input type="checkbox" class="form-check-input" id="updateShippingAddress"
                                        (change)="onUpdateShippingAddressInProfile()">
                                    <label class="form-check-label" for="updateShippingAddress">Update Shipping Address
                                        In Profile</label>
                                </div>
                            </div>
                            <div class="col-12" formGroupName="shippingAddress">

                                <h4>Shipping Address</h4>
                                <div class="mb-3">
                                    <label for="shippingAddress-line1" class="form-label">Address Line 1 <span
                                            class="text-danger">*</span></label>
                                    <input type="text" class="form-control" id="shippingAddress-line1" required
                                        formControlName="line1" [ngClass]="{'is-invalid': orderForm.get('shippingAddress.line1')?.invalid &&
                                         (orderForm.get('shippingAddress.line1')?.touched
                                        || orderForm.get('shippingAddress.line1')?.dirty )}">
                                    <div
                                        *ngIf="orderForm.get('shippingAddress.line1')?.invalid
                                        && (orderForm.get('shippingAddress.line1')?.touched || orderForm.get('shippingAddress.line1')?.dirty)">
                                        <ng-container *ngIf="orderForm.get('shippingAddress.line1')?.errors as errors">
                                            <small class="text-danger" *ngIf="errors['required']">
                                                Address Line 1 is required.
                                            </small>
                                            <small class="text-danger"
                                                *ngIf="!errors['required'] && errors['onlySpaces']">
                                                Address Line 1 cannot contain only spaces.
                                            </small>
                                            <small class="text-danger"
                                                *ngIf="!errors['required'] && !errors['onlySpaces'] && errors['maxlength']">
                                                Address Line 1 must be 200 characters or less.
                                            </small>
                                            <small class="text-danger"
                                                *ngIf="!errors['required'] && !errors['onlySpaces'] && !errors['maxlength'] && errors['maxlengthNoSpaces']">
                                                Address Line 1 (excluding spaces) must be 200 characters or less.
                                            </small>
                                            <small class="text-danger"
                                                *ngIf="!errors['required'] && !errors['onlySpaces'] && !errors['maxlength'] && !errors['maxlengthNoSpaces'] && errors['invalidPattern']">
                                                Address Line 1 contains invalid characters (only letters, numbers,
                                                spaces, and - , . / ( ) & # are allowed).
                                            </small>
                                        </ng-container>
                                    </div>
                                </div>

                                <div class="mb-3">
                                    <label for="shippingAddress-line2" class="form-label">Address Line 2 </label>
                                    <input type="text" class="form-control" id="shippingAddress-line2"
                                        formControlName="line2" [ngClass]="{'is-invalid': orderForm.get('shippingAddress.line2')?.invalid &&
                                         (orderForm.get('shippingAddress.line2')?.touched
                                        || orderForm.get('shippingAddress.line2')?.dirty)}">
                                    <div
                                        *ngIf="orderForm.get('shippingAddress.line2')?.invalid
                                         && (orderForm.get('shippingAddress.line2')?.touched || orderForm.get('shippingAddress.line2')?.dirty)">
                                        <ng-container *ngIf="orderForm.get('shippingAddress.line2')?.errors as errors">
                                            <small class="text-danger" *ngIf="errors['onlySpaces']">
                                                Address Line 2 cannot contain only spaces.
                                            </small>
                                            <small class="text-danger"
                                                *ngIf="!errors['onlySpaces'] && errors['maxlength']">
                                                Address Line 2 must be 200 characters or less.
                                            </small>
                                            <small class="text-danger"
                                                *ngIf="!errors['required'] && !errors['onlySpaces'] && !errors['maxlength'] && errors['maxlengthNoSpaces']">
                                                Address Line 2 (excluding spaces) must be 200 characters or less.
                                            </small>
                                            <small class="text-danger"
                                                *ngIf="!errors['required'] && !errors['onlySpaces'] && !errors['maxlength'] && !errors['maxlengthNoSpaces'] && errors['invalidPattern']">
                                                Address Line 2 contains invalid characters (only letters, numbers,
                                                spaces, and - , . / ( ) & # are allowed).
                                            </small>
                                        </ng-container>
                                    </div>
                                </div>

                                <div class="row">

                                    <div class="col-6 mb-3">
                                        <label id="shippingAddress-city" for="zip" class="form-label">
                                            City <span class="text-danger">*</span>
                                        </label>
                                        <input type="text" class="form-control" id="shippingAddress-city" required
                                            formControlName="city"
                                            [ngClass]="{'is-invalid': orderForm.get('shippingAddress.city')?.invalid &&
                                             (orderForm.get('shippingAddress.city')?.touched || orderForm.get('shippingAddress.city')?.dirty)}">
                                        <div *ngIf="(orderForm.get('shippingAddress.city')?.touched || orderForm.get('shippingAddress.city')?.dirty)
                                                && orderForm.get('shippingAddress.city')?.invalid">

                                            <ng-container
                                                *ngIf="orderForm.get('shippingAddress.city')?.errors as errors">

                                                <small class="text-danger" *ngIf="errors['required']">
                                                    City is required.
                                                </small>

                                                <small class="text-danger"
                                                    *ngIf="!errors['required'] && errors['onlySpaces']">
                                                    City cannot contain only spaces.
                                                </small>

                                                <small class="text-danger"
                                                    *ngIf="!errors['required'] && !errors['onlySpaces'] && errors['maxlength']">
                                                    City must be 100 characters or less.
                                                </small>

                                                <small class="text-danger"
                                                    *ngIf="!errors['required'] && !errors['onlySpaces'] && !errors['maxlength'] && errors['maxlengthNoSpaces']">
                                                    City (excluding spaces) must be 100 characters or less.
                                                </small>

                                                <small class="text-danger"
                                                    *ngIf="!errors['required'] && !errors['onlySpaces'] && !errors['maxlength'] && !errors['maxlengthNoSpaces'] && errors['pattern']">
                                                    City can only contain letters, spaces, and hyphens (-).
                                                </small>

                                            </ng-container>
                                        </div>
                                    </div>
                                    <div class="col-6 mb-3">
                                        <label for="shippingAddress-postalCode" class="form-label">
                                            Postal Code <span class="text-danger">*</span>
                                        </label>
                                        <input type="text" class="form-control" id="shippingAddress-postalCode"
                                            placeholder="3-12 character postal code" required
                                            formControlName="postalCode"
                                            [ngClass]="{'is-invalid': orderForm.get('shippingAddress.postalCode')?.invalid
                                            && (orderForm.get('shippingAddress.postalCode')?.touched || orderForm.get('shippingAddress.postalCode')?.dirty)}">
                                        <div *ngIf="(orderForm.get('shippingAddress.postalCode')?.touched || orderForm.get('shippingAddress.postalCode')?.dirty)
                                            && orderForm.get('shippingAddress.postalCode')?.invalid">

                                            <ng-container
                                                *ngIf="orderForm.get('shippingAddress.postalCode')?.errors as errors">

                                                <small class="text-danger" *ngIf="errors['required']">
                                                    Postal code is required.
                                                </small>

                                                <small class="text-danger"
                                                    *ngIf="!errors['required'] && errors['onlySpaces']">
                                                    Postal code cannot contain only spaces.
                                                </small>

                                                <small class="text-danger"
                                                    *ngIf="!errors['required'] && !errors['onlySpaces'] && errors['leadingOrTrailingSpaces']">
                                                    Postal code cannot start or end with a space.
                                                </small>

                                                <small class="text-danger"
                                                    *ngIf="!errors['required'] && !errors['onlySpaces'] && !errors['leadingOrTrailingSpaces'] && errors['maxlength']">
                                                    Postal code cannot exceed 12 characters.
                                                </small>

                                                <small class="text-danger"
                                                    *ngIf="!errors['required'] && !errors['onlySpaces'] && !errors['leadingOrTrailingSpaces'] && !errors['maxlength'] && errors['pattern']">
                                                    Postal code must be 3–12 characters, using only letters, numbers,
                                                    spaces, or hyphens.
                                                </small>
                                            </ng-container>
                                        </div>
                                    </div>

                                    <div class="col-6 mb-3">
                                        <label for="shippingAddress-country" class="form-label">
                                            Country <span class="text-danger">*</span>
                                        </label>
                                        <select id="shippingAddress-country" formControlName="country"
                                            class="form-control"
                                            [ngClass]="{'is-invalid': orderForm.get('shippingAddress.country')?.invalid &&
                                            ((orderForm.get('shippingAddress.country')?.touched) || orderForm.get('shippingAddress.country')?.dirty)}">
                                            <option value="" disabled selected>Select Country</option>
                                            <option *ngFor="let country of countriesOptions$ | async"
                                                [value]="country.code">
                                                {{ country.name }}
                                            </option>
                                        </select>
                                        <div *ngIf="(orderForm.get('shippingAddress.country')?.touched || orderForm.get('shippingAddress.country')?.dirty)
                                         && orderForm.get('shippingAddress.country')?.invalid">
                                            <small class="text-danger"
                                                *ngIf="orderForm.get('shippingAddress.country')?.errors?.['required']">
                                                Country is required.
                                            </small>
                                        </div>
                                    </div>
                                    <div class="col-6 mb-3">
                                        <label for="shippingAddress-state" class="form-label">
                                            State <span class="text-danger">*</span>
                                        </label>
                                        <select id="shippingAddress-state" formControlName="state" class="form-control"
                                            [ngClass]="{'is-invalid': orderForm.get('shippingAddress.state')?.invalid &&
                                            (orderForm.get('shippingAddress.state')?.touched || orderForm.get('shippingAddress.state')?.dirty)}">
                                            <option value="" disabled selected>Select State</option>
                                            <option *ngFor="let state of shippingStatesOptions" [value]="state">
                                                {{ state }}
                                            </option>
                                        </select>
                                        <div *ngIf="(orderForm.get('shippingAddress.state')?.touched || orderForm.get('shippingAddress.state')?.dirty)
                                         && orderForm.get('shippingAddress.state')?.invalid">
                                            <small class="text-danger"
                                                *ngIf="orderForm.get('shippingAddress.state')?.errors?.['required']">
                                                State is required.
                                            </small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>

                <!-- Your Order Section -->
                <div class="col-5">
                    <!-- Order Summary Card -->
                    <div class="card summary-card">
                        <div class="card-body">
                            <h4 class="card-title" style="text-align: center;">Payment Summary</h4>
                            <div class="d-flex justify-content-between mb-2">
                                <div class="label-currency">
                                    <span>Plan:</span>
                                </div>
                                <span class="amount">{{selectedSubscription?.Name}}</span>
                            </div>
                            <hr>
                            <div class="d-flex justify-content-between mb-2">
                                <div class="label-currency">
                                    <span>Billing Cycle:</span>
                                </div>
                                <span class="amount">{{selectedSubscription?.BillingCycle}}</span>
                            </div>
                            <hr>
                            <div class="d-flex justify-content-between mb-2">
                                <div class="label-currency">
                                    <span>Price:</span>
                                </div>
                                <span class="amount">{{getCurrSymbol(selectedSubscription?.Currency || '')}}
                                    {{formatAmount(selectedSubscription?.Price, selectedSubscription?.Currency)}}</span>
                            </div>
                            <div class="d-flex justify-content-between mb-2 discount"
                                *ngIf="subscriptionPlan && getDiscount(subscriptionPlan!) as discount">
                                <div class="label-currency">
                                    <span>Discount (Save {{getDiscountedPercentage(selectedSubscription)}}%):</span>
                                </div>
                                <span class="amount">{{getCurrSymbol(selectedSubscription?.Currency || '')}}
                                    {{formatAmount(selectedSubscription?.Discount,
                                    selectedSubscription?.Currency)}}</span>
                            </div>
                            <hr>
                            <div class="d-flex justify-content-between mb-2"
                                *ngIf="selectedSubscription?.Price != getDiscountedPrice(selectedSubscription)">
                                <div class="label-currency">
                                    <span>Discounted Price:</span>
                                </div>
                                <span class="amount">{{getCurrSymbol(selectedSubscription?.Currency || '')}}
                                    {{formatAmount(getDiscountedPrice(selectedSubscription),
                                    selectedSubscription?.Currency)}}</span>
                            </div>
                            <hr *ngIf="selectedSubscription?.Price != getDiscountedPrice(selectedSubscription)">
                            <div class="d-flex justify-content-between mb-2"
                                *ngIf="selectedSubscription?.Currency === 'INR'">
                                <div class="label-currency">
                                    <span>GST:</span>
                                </div>
                                <span class="amount">{{getCurrSymbol(selectedSubscription?.Currency || '')}}
                                    {{formatAmount(selectedSubscription?.GST, selectedSubscription?.Currency)}}</span>
                            </div>
                            <div class="d-flex justify-content-between mb-2"
                                *ngIf="selectedSubscription?.Currency !== 'INR' && selectedSubscription?.OtherTax">
                                <div class="label-currency">
                                    <span>Other Tax:</span>
                                </div>
                                <span class="amount">{{getCurrSymbol(selectedSubscription?.Currency || '')}}
                                    {{formatAmount(selectedSubscription?.OtherTax,
                                    selectedSubscription?.Currency)}}</span>
                            </div>
                            <hr *ngIf="selectedSubscription?.Currency === 'INR' || selectedSubscription?.OtherTax">
                            <div class="d-flex justify-content-between">
                                <div class="label-currency">
                                    <span>Final Amount:</span>
                                </div>
                                <span class="amount">{{getCurrSymbol(selectedSubscription?.Currency || '')}}
                                    {{formatAmount(selectedSubscription?.FinalAmount,
                                    selectedSubscription?.Currency)}}</span>
                            </div>
                        </div>
                        <button class="btn btn-primary save-btn" type="submit" (click)="onPaymentClick()"
                            [disabled]="orderForm.invalid">
                            {{orderState.status === "Loading"? "Processing...": orderState.status ===
                            "Success" ? "Processing...": "Place Order"}}
                        </button>
                        <div class="terms-and-conditions-container">
                          By placing an order, you agree to our
                          <span>
                            <a class="policy-item" [href]="serviceURLS.termsOfServiceURL" target="_blank">Terms of Service</a>,
                            <a class="policy-item" [href]="serviceURLS.refundPolicyURL" target="_blank">Refund Policy</a>
                            <span>&</span>
                            <a class="policy-item" [href]="serviceURLS.privacyPolicyURL" target="_blank">Privacy Policy</a>
                          </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>